import React, { useEffect, useState } from "react";
import BlueColorLogo from "../../image/BlueColorLogo.svg";
import WelcomepageDesign from "../../image/Welcomepage-Design.svg";
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import "./onboarding.css";
import { Form, FormBuilder, Formio } from "@formio/react";
import ClerkRegister from "./ClerkRegister";
import ClientRegister from "./ClientRegister";
import { Link } from "react-router-dom";

const Onboarding = (props) => {
  const [addition, setaddition] = useState(false);
  const [submissiondata, setsubmissiondata] = useState(null);
  // saves the form data inside the submissions mongodb database

  useEffect(() => {
    setaddition(false);
  }, []);

  const Registernsave = async (id, submission) => {
    const response = await fetch(
      `http://localhost:3001/form/${id}/submission`,
      {
        method: "POST", // *GET, POST, PUT, DELETE, etc.
        mode: "cors", // no-cors, *cors, same-origin
        cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
        // credentials: 'same-origin', // include, *same-origin, omit
        headers: {
          "Content-Type": "application/json",

          "x-jwt-token": process.env.REACT_APP_X_JWT_TOKEN,
          // 'Content-Type': 'application/x-www-form-urlencoded',
        },
        redirect: "follow", // manual, *follow, error
        referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
        body: JSON.stringify(submission), // body data type must match "Content-Type" header
      }
    )
      .then((data) => {
        data.json().then((data) => {
          const changepayload = {
            formId: id,
            formUrl: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3001/form/${id}/submission/${data._id}`,
            submissionId: data._id,
            webFormUrl: `http://${process.env.REACT_APP_MY_CURRENT_IP}:3000/form/${id}/submission/${data._id}`,
          };

          const createApicall = async () => {
            const response = await fetch(
              "http://localhost:5000/application/create",
              {
                method: "POST", // *GET, POST, PUT, DELETE, etc.
                mode: "cors", // no-cors, *cors, same-origin
                cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                // credentials: 'same-origin', // include, *same-origin, omit
                headers: {
                  "Content-Type": "application/json",
                  "Content-Length": 312,

                  Authorization: process.env.REACT_APP_5000_BEARER_TOKEN,
                  // 'Content-Type': 'application/x-www-form-urlencoded',
                },
                redirect: "follow", // manual, *follow, error
                referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: JSON.stringify(changepayload), // body data type must match "Content-Type" header
              }
            )
              .then((data) => {
                data.json().then((data) => {});
              })
              .catch((err) => {
                console.log(err);
              });
          };

          createApicall();
        });
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveallthree = async (submission) => {
    setaddition(true);
  };

  function logout() {
    // props.history.push('/');

    props.state.keycloak.logout();
  }

  const onSubmitHandler = async (submission) => {
    setsubmissiondata(submission);

    let uniqueEmailArray = [
      JSON.parse(localStorage.getItem("UserDetails")).email,
      submission.data.clientemail,
      submission.data.clerkemail,
      submission.data.approveremail,
    ];

    if (!(uniqueEmailArray.length === new Set(uniqueEmailArray).size)) {
      alert("Email addess should be unique!!!");
      return;
    }

    await Registernsave(
      process.env.REACT_APP_ONBOARDINGFORM_FORMID,
      submission
    ).then(() => {
      saveallthree(submission);
    });

    return;
  };

  const obj2 = JSON.parse(localStorage.getItem("formArray"));

  return (
    <>
      <div>
        <div className="navbar nav WelcomeNavbar">
          <div>
            <span>
              <img src={BlueColorLogo} className="LogoWith-green-Color" />
            </span>
            <span className="WelcomePage-Date">
              {new Date().toLocaleDateString("en-US", {
                weekday: "long",
                day: "numeric",
                month: "short",
                year: "numeric",
              })}
            </span>
          </div>
          <div>
            <span className="accountHolder">
              <Button
                className="AccountHolder Settings btn"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
              >
                {JSON.parse(
                  localStorage.getItem("UserDetails")
                ).preferred_username.slice(0, 1)}
              </Button>
              <div
                className="dropdown-menu"
                aria-labelledby="dropdownMenuButton"
              >
                <span className="dropdown-item">user</span>
                <hr />
                <span onClick={logout} className="dropdown-item">
                  Logout
                </span>
              </div>
            </span>
          </div>
        </div>
      </div>
      <div className="OnboardingPage">
        <div className="Onboarding-Lefthand-Side">
      
          <div>
            <div className="PopupModel">
              <div ng-app="formApp">
                <Form
                  form={obj2}
                  onSubmit={onSubmitHandler}
                  className="progress"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <img
            src={WelcomepageDesign}
            alt="Welcome page Design"
            className="WelcomePage-Side-Design"
          />
        </div>
      </div>

      {addition && <ClientRegister submissiondata={submissiondata} />}
    </>
  );
};

export default Onboarding;
